import { Colors } from "../../../utils/colors";
import { useSelector } from "react-redux";
import { getAccountState } from "../../../redux/slices/accountSlice";
import { Icon } from "@iconify/react";
import { TeamMemberRole } from "@markit/common.types";
import { onCreatorPanelNavigatePath } from "../../../utils/navigationUtils";
import { useNavigate } from "react-router-dom";
import { CSSProperties } from "react";
import { NavigationId } from "../../../navigation/AppParamList";

type TeamMemberRoleBannerProps = {
  disabled?: boolean;
  containerStyles?: CSSProperties;
};
const TeamMemberRoleBanner = (props: TeamMemberRoleBannerProps) => {
  const { disabled, containerStyles } = props;
  const { teamMemberData, accountData } = useSelector(getAccountState).account;
  const navigate = useNavigate();

  return teamMemberData ? (
    <div
      className="ColumnNormalSelect"
      style={{
        paddingBlock: 8,
        paddingInline: 12,
        borderRadius: 8,
        backgroundColor: Colors.BLUE5,
        color: Colors.WHITE,
        gap: 3,
        pointerEvents: disabled ? "none" : "auto",
        ...containerStyles,
      }}
      onClick={() =>
        onCreatorPanelNavigatePath(
          navigate,
          NavigationId.HOME_SETTINGS,
          teamMemberData.role === TeamMemberRole.TWO_WAY_SUPPORT ? 1 : 3
        )
      }
    >
      <div className="AlignedRow" style={{ gap: 4 }}>
        <span className="bodySmallMedium" style={{ fontWeight: 500 }}>
          Viewing as{" "}
          {teamMemberData.role === TeamMemberRole.FULL_ACCESS
            ? "Full Admin"
            : "Support"}
        </span>
        {!disabled ? (
          <Icon
            icon="ion:chevron-right"
            height={10}
            style={{ color: Colors.WHITE }}
          />
        ) : null}
      </div>
      <span style={{ fontSize: 10 }}>
        You are a team member for {accountData.fullName}
      </span>
    </div>
  ) : null;
};

export default TeamMemberRoleBanner;
